document.addEventListener("DOMContentLoaded", () => {
  const searchParams = localStorage.getItem("searchParams");

  if (searchParams) {
    const links = document.querySelectorAll('a[href$="collections/all"]');

    links.forEach((link) => {
      if (link.classList.contains("active-facets__button-remove--remove-all")) {
        return;
      }
      const url = new URL(link.href);
      url.search = searchParams;
      link.href = url.toString();
    });
  }
});

class SliderContainer extends HTMLElement {
  #filled = true;
  #openTimeoutId = null;
  #closeTimeoutId = null;
  #touchStartY = 0;
  #touchEndY = 0;
  #initialScrollTop = 0;
  constructor() {
    super();

    this.content = this.querySelector(".sc__content");
    this.scrollContainer = this.querySelector(".sc__container");
    this.mobileCloseBtn = this.querySelector(".close-btn.mobile-only");
    this.closeElements = [...this.querySelectorAll(".close-btn, .overlay")];
    this.sliderWindows = [...this.querySelectorAll(".single-column-table-section.addon-popover")];
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
  }

  connectedCallback() {
    this.closeElements.forEach((closeBtn) => {
      closeBtn.addEventListener("click", this.close);
    });
    this.sliderWindows.forEach((sliderWindow) => {
      sliderWindow.addEventListener("click", this.close);
    });
    this.addEventListener("touchstart", this.handleTouchStart, { passive: true });
    this.addEventListener("touchmove", this.handleTouchMove, { passive: true });
    this.addEventListener("touchend", this.handleTouchEnd);
  }

  disconnectedCallback() {
    this.closeElements.forEach((closeBtn) => {
      closeBtn.removeEventListener("click", this.close);
    });
    this.sliderWindows.forEach((sliderWindow) => {
      sliderWindow.removeEventListener("click", this.close);
    });
    this.removeEventListener("touchstart", this.handleTouchStart);
    this.removeEventListener("touchmove", this.handleTouchMove);
    this.removeEventListener("touchend", this.handleTouchEnd);
    this.#clearTimers();
  }

  #clearTimers() {
    if (this.#openTimeoutId) {
      clearTimeout(this.#openTimeoutId);
      this.#openTimeoutId = null;
    }
    if (this.#closeTimeoutId) {
      clearTimeout(this.#closeTimeoutId);
      this.#closeTimeoutId = null;
    }
  }

  fillContent(HTMLString) {
    if (!this.content) {
      this.#filled = false;
      console.error("SliderContainer missing .sc__content element");
      return;
    }
    try {
      this.content.innerHTML = HTMLString;
      this.#filled = true;
    } catch (error) {
      this.#filled = false;
      throw new Error(error);
    }
  }

  open() {
    if (this.#filled === false) {
      console.error("ERROR! When filling can't open the slider");
      return;
    }
    if (this.classList.contains("open") && !this.classList.contains("closing")) {
      return;
    }
    this.#clearTimers();
    this.classList.remove("closing");
    this.classList.add("opening");
    this.#openTimeoutId = window.setTimeout(() => {
      this.classList.add("open");
      this.classList.remove("opening");
    }, 100);
  }

  close() {
    if (
      !this.classList.contains("open") &&
      !this.classList.contains("opening")
    ) {
      return;
    }
    this.#clearTimers();
    this.classList.remove("opening");
    this.classList.add("closing");
    this.#closeTimeoutId = window.setTimeout(() => {
      this.classList.remove("open");
      this.classList.remove("closing");
    }, 700);
  }

  handleTouchStart(e) {
    this.#touchStartY = e.changedTouches[0].screenY;
    this.#touchEndY = e.changedTouches[0].screenY;
    this.#initialScrollTop = this.scrollContainer ? this.scrollContainer.scrollTop : 0;
  }

  handleTouchMove(e) {
    this.#touchEndY = e.changedTouches[0].screenY;
  }

  handleTouchEnd(e) {
    if (!this.mobileCloseBtn || this.mobileCloseBtn.offsetParent === null) {
      return;
    }
    if (!e.target.closest(".single-column-table-section.addon-popover")) {
      return;
    }
    if (this.#initialScrollTop > 0) {
      return;
    }
    if (this.#touchEndY - this.#touchStartY > 100) {
      this.close();
    }
  }
}

customElements.define("slider-container", SliderContainer);

class MarqueeItem extends HTMLElement {
  #resizeFrame = null;
  constructor() {
    super();
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    // Only adjust if the marquee is rotated
    if (
      this.classList.contains("marque-angle-direction-to-top") ||
      this.classList.contains("marque-angle-direction-to-bottom")
    ) {
      this.adjustParentHeight();
      window.addEventListener("resize", this.handleResize);
    }
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    if (this.#resizeFrame) {
      cancelAnimationFrame(this.#resizeFrame);
      this.#resizeFrame = null;
    }
  }

  handleResize() {
    if (this.#resizeFrame) {
      cancelAnimationFrame(this.#resizeFrame);
    }
    this.#resizeFrame = requestAnimationFrame(() => {
      this.adjustParentHeight();
      this.#resizeFrame = null;
    });
  }

  adjustParentHeight() {
    const parent = this.closest(".angle-marquee-block");
    if (!parent) return;

    let minChildTop = Infinity;
    let maxChildBottom = -Infinity;

    const rotatedItems = parent.querySelectorAll(
      "marquee-item.marque-angle-direction-to-top, marquee-item.marque-angle-direction-to-bottom",
    );

    rotatedItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      minChildTop = Math.min(minChildTop, rect.top);
      maxChildBottom = Math.max(maxChildBottom, rect.bottom);
    });

    const parentRect = parent.getBoundingClientRect();
    const newHeight = maxChildBottom - Math.min(parentRect.top, minChildTop);
    parent.style.height = `${newHeight}px`;
  }
}

customElements.define("marquee-item", MarqueeItem);

class CustomRecommendations extends HTMLElement {
  constructor() {
    super();
    this.isAvailable = this.dataset.available === "true";
    this.url = this.dataset.url;
    this.container = this.querySelector(".product-grid");
    this._innit();
  }

  _innit() {
    if (!this.isAvailable) {
      this._runOutOfStock();
      return;
    }
  }
  async getAlternativeCollection() {
    if (!this.url) {
      return [];
    }

    try {
      const response = await fetch(this.url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, "text/html");

      const productGrid = doc.querySelector("ul.product-grid");
      if (!productGrid) {
        return [];
      }

      // get three first products
      const items = Array.from(productGrid.querySelectorAll(".grid__item"))
        .filter((item) => item.children)
        .slice(0, 3);
      return items;
    } catch (error) {
      console.error("Error fetching or parsing HTML:", error);
      return [];
    }
  }
  async _runOutOfStock() {
    const items = await this.getAlternativeCollection();
    if (!this.container || items.length === 0) {
      return;
    }

    items.forEach((item) => {
      this.container.appendChild(item);
    });
  }
}

customElements.define("custom-recommendations", CustomRecommendations);

const markResponsiveModalVisible = () => {
  const pdpPopup = document.querySelector(".react-responsive-modal-root");

  if (pdpPopup && !pdpPopup.classList.contains("show-popup")) {
    pdpPopup.classList.add("show-popup");
    window.removeEventListener("scroll", markResponsiveModalVisible);
  }
};

window.addEventListener("scroll", markResponsiveModalVisible, { passive: true });
markResponsiveModalVisible();

class ProductManuals extends HTMLElement {
  static sizeCache = new Map();
  static pendingRequests = new Map();

  constructor() {
    super();

    this.initElementsSize();
  }

  async getFileSize(url) {
    if (ProductManuals.sizeCache.has(url)) {
      return ProductManuals.sizeCache.get(url);
    }

    if (ProductManuals.pendingRequests.has(url)) {
      return ProductManuals.pendingRequests.get(url);
    }

    const request = (async () => {
      try {
        const response = await fetch(url, { method: "HEAD" });

        if (!response.ok) {
          throw new Error("Failed to fetch headers");
        }

        const size = response.headers.get("Content-Length");
        if (size !== null) {
          const parsedSize = Number(size);
          ProductManuals.sizeCache.set(url, parsedSize);
          return parsedSize;
        }

        console.error("Content-Length header not available");
        return null;
      } catch (error) {
        console.error("Error getting file size:", error);
        return null;
      } finally {
        ProductManuals.pendingRequests.delete(url);
      }
    })();

    ProductManuals.pendingRequests.set(url, request);
    return request;
  }
  initElementsSize() {
    const linkEls = this.querySelectorAll(".product-manuals__link");
    linkEls.forEach(async (el) => {
      const sizeBlock = el.querySelector(".product-manuals__file-size");
      if (!sizeBlock) {
        return;
      }

      const size = await this.getFileSize(el.href);
      if (size) {
        sizeBlock.innerHTML = `${(Number(size) / (1024 * 1024)).toFixed(2)} MB`;
      }
    });
  }
}

customElements.define("product-manuals", ProductManuals);

// Global delegated listener for injecting page content into the slider-container
document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".js-get-page-content");
  if (!btn) return;

  e.preventDefault();

  const href = btn.getAttribute("href");
  if (!href) return;

  const slider = document.querySelector("slider-container");
  if (!slider) return;

  // Open slider immediately with a loading state
  slider.fillContent('<div style="padding: 4rem; text-align: center; font-size: 1.6rem; color: var(--color-gray-500);">Loading...</div>');
  slider.open();

  try {
    const response = await fetch(href);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const pageContent = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(pageContent, "text/html");
    const mainContent = doc.querySelector("main")?.innerHTML || "<p>Main content not found</p>";

    slider.fillContent(mainContent);
  } catch (error) {
    console.error("Error fetching page content:", error);
    slider.fillContent('<div style="padding: 4rem; text-align: center; color: red;">Error loading content. Please try again.</div>');
  }
});

// Global delegated listener for fetching and injecting page content into cart-addons-flyover__content
document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".js-fetch-flyover-content");
  if (!btn) return;

  const href = btn.getAttribute("href") || btn.getAttribute("data-href");
  if (!href) return;

  const wrapper = btn.closest(".cart-addons-flyover-wrapper");
  const flyover = wrapper ? wrapper.querySelector(".cart-addons-flyover") : null;
  if (!flyover) return;

  const contentContainer = flyover.querySelector(".cart-addons-flyover__content");
  if (!contentContainer) return;

  if (contentContainer.dataset.loaded === "true" || contentContainer.dataset.loading === "true") return;

  // Set loading state to prevent duplicate concurrent requests
  contentContainer.dataset.loading = "true";
  contentContainer.innerHTML = '<div style="padding: 4rem; text-align: center; font-size: 1.6rem; color: var(--color-gray-500);">Loading...</div>';

  try {
    const response = await fetch(href);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const pageContent = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(pageContent, "text/html");
    const mainContent = doc.querySelector("main")?.innerHTML || "<p>Main content not found</p>";

    contentContainer.innerHTML = mainContent;
    contentContainer.dataset.loaded = "true";
  } catch (error) {
    console.error("Error fetching page content:", error);
    contentContainer.innerHTML = '<div style="padding: 4rem; text-align: center; color: red;">Error loading content. Please try again.</div>';
  } finally {
    contentContainer.dataset.loading = "false";
  }
});
